var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUsers = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8329 9.40402H13.5826C13.71 9.75294 13.7797 10.1295 13.7797 10.522V15.2474C13.7797 15.411 13.7512 15.5681 13.6994 15.7142H15.7664C16.5385 15.7142 17.1667 15.086 17.1667 14.3139V11.7378C17.1667 10.451 16.1198 9.40402 14.8329 9.40402Z",
    fill: "#5D5CF5",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38706 10.5221C4.38706 10.1296 4.45669 9.75304 4.58413 9.40411H3.33383C2.04695 9.40411 1 10.4511 1 11.7379V14.314C1 15.0861 1.62815 15.7143 2.4003 15.7143H4.46736C4.41555 15.5682 4.38706 15.4111 4.38706 15.2475V10.5221V10.5221Z",
    fill: "#5D5CF5",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5136 8.1875H7.65524C6.36837 8.1875 5.32141 9.23445 5.32141 10.5213V15.2468C5.32141 15.5045 5.53039 15.7135 5.78818 15.7135H12.3807C12.6385 15.7135 12.8474 15.5046 12.8474 15.2468V10.5213C12.8474 9.23445 11.8005 8.1875 10.5136 8.1875Z",
    fill: "#5D5CF5",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08357 2C7.53594 2 6.27686 3.25909 6.27686 4.80675C6.27686 5.85651 6.85625 6.77334 7.71192 7.2547C8.11777 7.48299 8.58567 7.61347 9.08357 7.61347C9.58147 7.61347 10.0494 7.48299 10.4552 7.2547C11.3109 6.77334 11.8903 5.85648 11.8903 4.80675C11.8903 3.25912 10.6312 2 9.08357 2Z",
    fill: "#5D5CF5",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15484 4.61606C2.9974 4.61606 2.05579 5.55767 2.05579 6.71511C2.05579 7.87255 2.9974 8.81417 4.15484 8.81417C4.44844 8.81417 4.72802 8.75335 4.98199 8.64403C5.42109 8.45498 5.78315 8.12034 6.00719 7.70116C6.16444 7.40696 6.2539 7.07133 6.2539 6.71511C6.2539 5.5577 5.31228 4.61606 4.15484 4.61606Z",
    fill: "#5D5CF5",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.012 4.61606C12.8546 4.61606 11.913 5.55767 11.913 6.71511C11.913 7.07136 12.0024 7.40699 12.1597 7.70116C12.3837 8.12037 12.7458 8.45502 13.1849 8.64403C13.4388 8.75335 13.7184 8.81417 14.012 8.81417C15.1695 8.81417 16.1111 7.87255 16.1111 6.71511C16.1111 5.55767 15.1695 4.61606 14.012 4.61606Z",
    fill: "#5D5CF5",
    fillOpacity: 0.8
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUsers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/users.5186a076.svg";
export { ForwardRef as ReactComponent };